<template>
  <div class="about">
    <h1>This is an about page</h1>
    <p>这是掌上温岭app里的扩展程序</p>
    <div>
      {{ info }}
    </div>

    <van-cell-group v-if="!showBtns">
      <van-field
        v-model="password"
        label=""
        type="password"
        placeholder="请输入通关密语"
        v-on:keyup.enter="doSubmit"
      />
    </van-cell-group>

    <div v-else>
      <van-cell-group>
        <van-button @click="getUserInfo">getUserInfo</van-button>
        <van-button @click="setData">setData</van-button>
        <van-button @click="doVerify">testVerify</van-button>
        <van-button @click="dojwtSign">jwtSign</van-button>
        <van-button @click="dojwtDecode">jwtdecode</van-button>
        <van-button @click="doClearStorage">clearStorage</van-button>
        <van-button to="product/list">productList</van-button>
        <van-button @click="doClosePage">close page</van-button>
        <van-button type="info" @click="doRefresh">刷新</van-button>
      </van-cell-group>

      <div>
        <van-field
          v-model="mobile"
          center
          clearable
          label="手机号码"
          placeholder="请输入手机号码"
        >
          <template #button>
            <van-button size="small" type="primary" @click="doFindByMobile"
              >提交</van-button
            >
          </template>
        </van-field>
      </div>
    </div>
  </div>
</template>

<script>
const jwt = require("jsonwebtoken");
import { login, findByMobile } from "@/api/api";
import { JWTverify, newSign } from "@/utils/jwt";
import storage from "@/utils/storage";

export default {
  name: "About",
  data() {
    return {
      showBtns: true,
      password: "",
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImFjY291bnRfaWQiOiI1YmZkZWMxNGE2MWQ1NjM1NjVmZTIzODEiLCJvcmlnaW4iOiJ6c3dsQXBwIn0sImlhdCI6MTY1Mzg3Mzk4MSwiZXhwIjoxNjg1NDMxNTgxfQ.4dW8uYjcpnvbbqPDAEdIgvJyhvPga9UX6TcOPc_C8_4",
        // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImFjY291bnRfaWQiOiI2MTgwYzllODkyYmEyYzA0ZTE1MDQ4OTkiLCJvcmlnaW4iOiJ6c3dsQXBwIn0sImlhdCI6MTY3MzQwNjUzNywiZXhwIjoxNzA0OTY0MTM3fQ.MKTwfGXBXVNgDdJDO5IeZAo4eQpO7w4ZSIWpkvUCI-w",
        // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImFjY291bnRfaWQiOiI2MTgwYzllODkyYmEyYzA0ZTE1MDQ4OTkiLCJvcmlnaW4iOiJ6c3dsQXBwIn0sImlhdCI6MTY0MDQxODA3NywiZXhwIjoxNjcxOTc1Njc3fQ.3ItH61EgRX6y8q0uBoxLyiU4mUgUQ0h0H_DDjTj4UIM",
      info: null,
      accountId: "5bfdec14a61d563565fe2381",
      uniqueId: "5ff667ddb77d2e1bda5be438",
      appUser: {
        account_id: "5bfdec14a61d563565fe2381",
        head_img:
          "https://img.tmuyun.com/assets/20181026/1540548206184_5bd2e66e1b011b05f912138c.png",
        invitation_number: 0,
        mobile: "18267610831",
        nick_name: "砍蚊子",
        ref_code: "DSJ29L",
        ref_user_code: "",
        ref_user_uid: "81",
        score: 0,
        username: "砍蚊子",
      },
      zswlUser: {
        id: 1,
        nick_name: "砍蚊子",
        mobile: "18267610831",
      },
      mobile: "",
    };
  },
  methods: {
    doRefresh(){
      window.location.reload();
    },
    doClosePage(){
// window.opener=null;
// window.open("about:blank", "_top").close()
console.log(8888);
CP.closePage({
    completed: function(data){
        CP.tools.writelog('close_page', data);
    },
    cpIncompatible: function () {
         CP.tools.writelog('', '此环境不支持此方法');
    }
});
    },
    doFindByMobile() {
      findByMobile({ mobile: this.mobile })
        .then((res) => {
          console.log(res);
        })
        .error((err) => {
          console.log(err);
        });
    },
    doSubmit() {
      if (this.password == "wlrbnm") {
        this.showBtns = true;
      }
    },
    doClearStorage() {
      this.$storage.clear();
    },
    dojwtDecode() {
      let t = jwt.decode(this.token);
      console.log(t);
    },
    dojwtSign() {
      let t = newSign(this.accountId);
      if (t) {
        this.token = t;
      }
      console.log(t);
    },
    doVerify() {
      let t = JWTverify(this.token);
      console.log(t);
    },
    getUserInfo() {
      login({ app_user: storage.get("appUser") });
    },
    setData() {
      this.$storage.set("appUser", this.appUser);
      this.$storage.set("zswlUser", this.zswlUser);
      this.$storage.set("uniqueId", this.uniqueId);
      this.$storage.set("accountId", this.accountId);
      this.$storage.set(
        "token",
        this.token
      );
    },
  },
};
</script>
